export class Pageable {
    size: number;
    page: number;
    sort?: string;
    direction?: 'asc' | 'desc' | '';
}
